import { defineMessages } from '@cookbook/solid-intl'

// Split out of `property-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Manage your property details on Lodgr. Update your listing, settings, and availability quickly and easily.',
        id: 'PropertyPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Manage Listing | Lodgr',
        id: 'PropertyPage.titleMessage',
    }),
}
